import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminAuth, clearToken, getToken, setToken } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, obj = authed
  const [mustChange, setMustChange] = useState(false);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    try {
      const me = await adminAuth.me();
      setUser(me);
      setMustChange(!!me.must_change_password);
    } catch {
      clearToken();
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const res = await adminAuth.login({ email, password });
    setToken(res.access_token);
    setUser(res.user);
    setMustChange(!!res.must_change_password);
    return res;
  };

  const logout = async () => {
    try {
      await adminAuth.logout();
    } catch {
      /* ignore */
    }
    clearToken();
    setUser(false);
    setMustChange(false);
  };

  const changePassword = async (current_password, new_password) => {
    const r = await adminAuth.changePassword({ current_password, new_password });
    if (r?.access_token) setToken(r.access_token);
    setMustChange(false);
    await refresh();
    return r;
  };

  return (
    <AuthContext.Provider
      value={{ user, mustChange, login, logout, changePassword, refresh, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
